import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {
    DataGrid,
    GridActionsCellItem,
    GridColDef,
    GridEventListener,
    GridRowEditStopReasons,
    GridRowId,
    GridRowModesModel,
    GridToolbarContainer,
    ptBR
} from '@mui/x-data-grid';

import { Grid, Icon, TableCell, Typography } from '@mui/material';
import { CustomButton } from 'components/roundedbutton/CustomButton';
import { useSnackbarCustom } from 'hooks/useSnackCustom';
import CustomPercent from 'pages/Venda/CustomPercent';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks';
import HeaderOuBannerDependendoDaInterpretacaoH1, { headerOuBannerDependendoDaInterpretacaoH1defaultFontSize } from 'layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1';
import CustomDialog from 'components/custom/CustomDialog';
import { CustomSwitch } from 'pages/cadastro-pessoa/CadastroPessoa';
import { theme } from 'theme';
import { clamp, currencyOf, deepClone, deepCopy, roundHalfToEven } from 'utils/util';
import ConfiguracaoDescontoAcrescimoService from './configuracao-desconto-acrescimo.service';
import ConfiguracaoDescontoAcrescimoModal from './ConfiguracaoDescontoAcrescimoModal';
import { ConfiguracoesChildrenProps } from './Configuracoes';
import { ConfigurarDescontosInitialState as ConfigurarDescontosAcrescimosInitialState, UsuarioTO, rowGrid } from './Configuracoes.model';

const initialState: ConfigurarDescontosAcrescimosInitialState = {
    showAddConfiguracao: false,
    rows: [],
    usuarios: [],
    usuariosSelecionados: [],
    descontoMaximoNoItem: 0,
    descontoMaximoPedido: 0,
    acrescimoMaximoPedido: 0,
    autorizaDesconto: false,
    usuarioEdit: null,
    replicaOutrosEstabelecimentos: false,
    showConfirmaDelete: false
};

const ConfigurarDescontosAcrescimos = (props: ConfiguracoesChildrenProps) => {
    const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});
    const [stateLocal, setStateLocal] = useState(initialState);
    const configuracaoDescontoService = ConfiguracaoDescontoAcrescimoService();
    const firstRenderRef = useRef(true);
    const navigate = useNavigate();
    const { addError, addSuccess, closeSnack } = useSnackbarCustom();
    const estabelecimento = useAppSelector(e => e.estabelecimentoSelecionado);
    const { caixaAberto } = useAppSelector(e => e.caixa.caixaAtual);


    const getDados = () => {
        let usuarios: Array<UsuarioTO> = [];
        let rows: Array<rowGrid> = [];

        configuracaoDescontoService.getUsuarios()
            .then(({ data }: { data: Array<UsuarioTO>; }) => {
                usuarios = data;
                return configuracaoDescontoService.getConfiguracoes();
            })
            .then(({ data }: { data: Array<rowGrid>; }) => {
                data.map((e, i) => e.id = e.usuario.toString());
                rows = data;

                rows.forEach(e => {
                    e.descontoMaximoItem = Number(e.descontoMaximoItem.toFixed(2));
                    e.descontoMaximoPedido = Number(e.descontoMaximoPedido.toFixed(2));
                });

                usuarios.forEach((e, i) => {
                    const find = rows.find(el => el.usuario === e.username);
                    if (find) {
                        usuarios.splice(i, 1);
                    }
                });
                setStateLocal(prevState => ({ ...prevState, rows, usuarios }));
            })
            .catch(err => {
                addError({ id: "getconfiguracoes-error", message: "Não foi possivel carregar suas configurações, tente novamente. Se o erro persistir, contate o suporte", closeable: true });
            });
    };

    useEffect(() => {
        if (firstRenderRef.current) {
            getDados();
        }
        firstRenderRef.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        getDados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [estabelecimento.uuid]);



    const openAddConfiguracao = useCallback(() => {
        setStateLocal(prevState => ({ ...prevState, showAddConfiguracao: true }));
    }, []);

    const closeAddConfiguracao = useCallback(() => {
        setStateLocal(prevState => ({
            ...prevState,
            showAddConfiguracao: false,
            usuariosSelecionados: initialState.usuariosSelecionados,
            descontoMaximoNoItem: initialState.descontoMaximoNoItem,
            descontoMaximoPedido: initialState.descontoMaximoPedido,
            autorizaDesconto: initialState.autorizaDesconto,
            replicaOutrosEstabelecimentos: initialState.replicaOutrosEstabelecimentos,
            usuarioEdit: initialState.usuarioEdit
        }));
    }, []);

    const addUsuario = useCallback((usuariosSelecionados: Array<UsuarioTO>) => {
        setStateLocal(prevState => ({ ...prevState, usuariosSelecionados }));
    }, []);

    const addAll = () => {
        const toReturn: Array<UsuarioTO> = [];
        const copiaDeUsuarios = [...stateLocal.usuarios];

        copiaDeUsuarios.forEach(e => {
            toReturn.push(e);
        });

        setStateLocal(prevState => ({ ...prevState, usuariosSelecionados: toReturn }));
    };

    const removeAll = () => {
        setStateLocal(prevState => ({ ...prevState, usuariosSelecionados: [] }));
    };


    const EditToolbar = () => {
        return (
            <GridToolbarContainer>
                <Button color='primary' startIcon={<AddIcon />} onClick={openAddConfiguracao}>
                    Adicionar configuração
                </Button>
            </GridToolbarContainer>
        );
    };

    const handleRowEditStop: GridEventListener<'rowEditStop'> = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id: GridRowId, row: rowGrid) => () => {
        setStateLocal(prevState => ({
            ...prevState,
            usuarioEdit: row,
            showAddConfiguracao: true,
            descontoMaximoNoItem: row.descontoMaximoItem,
            descontoMaximoPedido: row.descontoMaximoPedido,
            acrescimoMaximoPedido: row.acrescimoMaximoPedido,
            autorizaDesconto: row.autorizaDesconto
        }));
        // setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const canDeleteRef = useRef<boolean>(true);

    const idToDeleteRef = useRef<GridRowId | null>(null);

    const handleDeleteClick = (id: GridRowId) => () => {
        idToDeleteRef.current = id;
        setStateLocal(prevState => ({
            ...prevState,
            showConfirmaDelete: true
        }));
    };

    const processRowUpdate = (newRow: rowGrid) => {

        const getPercentualValue = (value: number | string) => {
            const sanitazedNumber = Number(value.toString().replace(',', '.'));
            const clampedNumber = clamp(sanitazedNumber, 0, 99.99);
            const fixedNumber = roundHalfToEven(clampedNumber, 2);
            return fixedNumber || 0;
        };

        const getValorMonetarioValue = (value: number | string) => {
            const sanitazedNumber = Number(value.toString().replace(',', '.'));
            const fixedNumber = roundHalfToEven(Math.max(0, sanitazedNumber), 2);
            return fixedNumber || 0;
        };

        newRow.descontoMaximoItem = getPercentualValue(newRow.descontoMaximoItem);
        newRow.descontoMaximoPedido = getPercentualValue(newRow.descontoMaximoPedido);
        newRow.acrescimoMaximoPedido = getValorMonetarioValue(newRow.acrescimoMaximoPedido);

        const updatedRow: rowGrid = deepClone(newRow);
        const copy = deepClone(stateLocal.rows);

        copy.forEach((e: rowGrid) => {
            if (e.id === updatedRow.id) {
                e.descontoMaximoItem = updatedRow.descontoMaximoItem;
                e.descontoMaximoPedido = updatedRow.descontoMaximoPedido;
                e.acrescimoMaximoPedido = updatedRow.acrescimoMaximoPedido;
                e.autorizaDesconto = updatedRow.autorizaDesconto;
            }
        });

        configuracaoDescontoService.updateConfiguracao(newRow)
            .then(() => {
                setStateLocal(prevState => ({ ...prevState, rows: copy }));
                addSuccess({ message: "Configuração do usuário atualizada com sucesso", closeable: true, hideDuration: 2000, id: "user-update-configuracao-desconto" });
            })
            .catch(err => {
                addError({ id: 'update-configuracao-error', message: 'Erro ao salvar, tente novamente. Se o erro persistir, entre em contato com o suporte', persist: false, closeable: true });
            });


        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const setDescontoItem = useCallback((maxDesc: number) => {
        setStateLocal(prevState => ({ ...prevState, descontoMaximoNoItem: maxDesc }));
    }, []);

    const setDescontoMaxPedido = useCallback((maxDesc: number) => {
        setStateLocal(prevState => ({ ...prevState, descontoMaximoPedido: maxDesc }));
    }, []);

    const setAcrescimoMaxPedido = useCallback((acrescimoMaximoPedido: number) => {
        setStateLocal(prevState => ({ ...prevState, acrescimoMaximoPedido }));
    }, []);

    const setAutorizaDesconto = useCallback((autoriza: string) => {
        if (autoriza.match("SIM")) {
            return setStateLocal(prevState => ({ ...prevState, autorizaDesconto: true }));
        }
        return setStateLocal(prevState => ({ ...prevState, autorizaDesconto: false }));
    }, []);


    const onConfirmModal = () => {
        if (stateLocal.usuarioEdit) {
            stateLocal.usuarioEdit.autorizaDesconto = stateLocal.autorizaDesconto;
            stateLocal.usuarioEdit.descontoMaximoItem = stateLocal.descontoMaximoNoItem;
            stateLocal.usuarioEdit.descontoMaximoPedido = stateLocal.descontoMaximoPedido;
            stateLocal.usuarioEdit.acrescimoMaximoPedido = stateLocal.acrescimoMaximoPedido;

            configuracaoDescontoService
                .saveAllConfiguracoes([stateLocal.usuarioEdit], stateLocal.replicaOutrosEstabelecimentos)
                .then(({ data }: { data: Array<rowGrid>; }) => {
                    data.forEach((el) => el.id = el.usuario.toString());

                    setStateLocal(prevState => ({
                        ...prevState,
                        rows: data
                    }));

                    addSuccess({
                        id: "users-added-sucess",
                        message: "Configurações criadas com sucesso",
                        closeable: true,
                        hideDuration: 2000,
                        persist: false
                    });
                })
                .catch(() => { })
                .finally(() => {
                    setStateLocal(prevState => ({
                        ...prevState,
                        showAddConfiguracao: false,
                        replicaOutrosEstabelecimentos: false,
                        autorizaDesconto: initialState.autorizaDesconto,
                        descontoMaximoNoItem: initialState.descontoMaximoNoItem,
                        descontoMaximoPedido: initialState.descontoMaximoPedido,
                        acrescimoMaximoPedido: initialState.acrescimoMaximoPedido,
                        usuarioEdit: null
                    }));
                });

            return;
        }


        let newRows: Array<rowGrid> = [];

        const novoUsuario: Array<UsuarioTO> = deepCopy(stateLocal.usuariosSelecionados);
        const usuarios: Array<UsuarioTO> = deepCopy(stateLocal.usuarios);
        const descontoMaximoItem = deepCopy(stateLocal.descontoMaximoNoItem);
        const descontoMaximoPedido = deepCopy(stateLocal.descontoMaximoPedido);
        const acrescimoMaximoPedido = deepCopy(stateLocal.acrescimoMaximoPedido);
        const autorizaDesconto = deepCopy(stateLocal.autorizaDesconto);


        novoUsuario.forEach((e: UsuarioTO) => {
            newRows.push({
                id: e.username.toString(),
                usuario: e.username,
                descontoMaximoItem: descontoMaximoItem,
                descontoMaximoPedido: descontoMaximoPedido,
                acrescimoMaximoPedido: acrescimoMaximoPedido,
                autorizaDesconto: autorizaDesconto,
                uuid: e.uuid
            });
        });

        if (newRows) {
            configuracaoDescontoService.saveAllConfiguracoes(newRows, stateLocal.replicaOutrosEstabelecimentos)
                .then(({ data }: { data: Array<rowGrid>; }) => {
                    data.forEach((el) => el.id = el.usuario.toString());
                    addSuccess({ id: "users-added-sucess", message: "Configurações criadas com sucesso", closeable: true, hideDuration: 2000, persist: false });
                    return setStateLocal((prevState) => ({
                        ...prevState,
                        rows: data,
                        showAddConfiguracao: false,
                        usuarios,
                        usuariosSelecionados: initialState.usuariosSelecionados,
                        descontoMaximoNoItem: initialState.descontoMaximoNoItem,
                        descontoMaximoPedido: initialState.descontoMaximoPedido,
                        acrescimoMaximoPedido: initialState.acrescimoMaximoPedido,
                        autorizaDesconto: initialState.autorizaDesconto
                    }));
                })
                .catch(() => {
                    return addError({ id: 'update-configuracoes-desconto-error', message: 'Não foi possivel atualizar as configuraçoes. Tente novamente, se o erro persistir, contate o suporte', persist: false, closeable: true });
                })
                .finally(() => {
                    setStateLocal(prevState => ({
                        ...prevState,
                        replicaOutrosEstabelecimentos: false,
                        autorizaDesconto: initialState.autorizaDesconto,
                        descontoMaximoNoItem: initialState.descontoMaximoNoItem,
                        descontoMaximoPedido: initialState.descontoMaximoPedido,
                        acrescimoMaximoPedido: initialState.acrescimoMaximoPedido,
                        usuarioEdit: null
                    }));
                });
        }
    };


    const columns: GridColDef[] = [
        {
            field: 'usuario',
            headerName: 'Usuário',
            type: 'string',
            width: 535,
            align: 'left',
            headerAlign: 'left',
            editable: false,
        },
        {
            field: 'descontoMaximoItem',
            headerName: 'Desconto máximo no item',
            type: 'string',
            width: 200,
            align: 'center',
            headerAlign: 'center',
            editable: true,
            renderCell: ({ row }: { row: rowGrid; }) => { // row}: {row: rowGrid}
                return (
                    <div key={`desconto_max_item_${row.uuid}`}>
                        <TableCell sx={{ fontSize: '14px' }}>{`${row.descontoMaximoItem}%`}</TableCell>
                    </div>
                );
            }
        },
        {
            field: 'descontoMaximoPedido',
            headerName: 'Desconto máximo no rodapé',
            type: 'string',
            width: 200,
            align: 'center',
            headerAlign: 'center',
            editable: true,
            renderCell: ({ row }: { row: rowGrid; }) => {
                return (
                    <div key={`desconto_max_item_${row.uuid}`}>
                        <TableCell sx={{ fontSize: '14px' }}>{`${row.descontoMaximoPedido}%`}</TableCell>
                    </div>
                );
            }
        },

        {
            field: 'acrescimoMaximoPedido',
            headerName: 'Acréscimo máximo no rodapé',
            type: 'string',
            width: 200,
            align: 'center',
            headerAlign: 'center',
            editable: true,
            renderCell: ({ row }: { row: rowGrid; }) => {
                return (
                    <div key={`acrescimo_${row.uuid}`}>
                        <TableCell sx={{ fontSize: '14px' }}>{currencyOf(row.acrescimoMaximoPedido)}</TableCell>
                    </div>
                );
            }
        },
        {
            field: 'autorizaDesconto',
            headerName: 'Autoriza desconto',
            type: 'singleSelect',
            width: 200,
            align: 'center',
            headerAlign: 'center',
            editable: true,
            valueOptions: [{
                value: false,
                label: "NÃO"
            }, {
                value: true,
                label: "SIM"
            }]
        },
        {
            field: 'acoes',
            type: 'actions',
            headerName: 'Ações',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id, row }) => {
                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id, row)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];

    const onToggleReplicarConfiguracaoDesconto = useCallback(() => {
        setStateLocal(prevState => ({
            ...prevState,
            replicaOutrosEstabelecimentos: !prevState.replicaOutrosEstabelecimentos
        }));
    }, []);

    const onCloseDeleteModal = () => {
        idToDeleteRef.current = null;
        setStateLocal(prevState => ({
            ...prevState,
            replicaOutrosEstabelecimentos: false,
            showConfirmaDelete: false,
            autorizaDesconto: initialState.autorizaDesconto,
            descontoMaximoNoItem: initialState.descontoMaximoNoItem,
            descontoMaximoPedido: initialState.descontoMaximoPedido,
            acrescimoMaximoPedido: initialState.acrescimoMaximoPedido,
        }));
    };

    const onConfirmDelete = useCallback(() => {
        if (canDeleteRef.current) {
            canDeleteRef.current = false;
            const rowToDelete = stateLocal.rows.find(e => e.id === idToDeleteRef.current);
            if (rowToDelete && rowToDelete.uuid) {
                configuracaoDescontoService.deleteConfiguracao(rowToDelete.uuid, stateLocal.replicaOutrosEstabelecimentos)
                    .then(() => {
                        closeSnack('user-delete-configuracao-desconto');
                        closeSnack('configurar-desconto-atualizar-error');
                        closeSnack('configurar-desconto-deletar-error');
                        canDeleteRef.current = true;
                        setStateLocal(prevState => ({ ...prevState, rows: stateLocal.rows.filter((row) => row.id !== idToDeleteRef.current) }));
                        configuracaoDescontoService.getUsuarios()
                            .then(({ data }: { data: Array<UsuarioTO>; }) => {
                                setStateLocal(prevState => ({ ...prevState, usuarios: data }));
                                addSuccess({
                                    message: "Configuração excluida com sucesso",
                                    closeable: true,
                                    hideDuration: 2000,
                                    id: "user-delete-configuracao-desconto",
                                    persist: false,
                                    preventDuplicate: false
                                });
                            })
                            .catch(() => {
                                addError({
                                    id: "configurar-desconto-atualizar-error",
                                    message: "Não foi possivel atualizar suas configurações, tente novamente. Se o erro persistir, contate o suporte",
                                    closeable: true
                                });
                                canDeleteRef.current = true;
                            });
                    })
                    .catch(() => {
                        addError({
                            id: "configurar-desconto-deletar-error",
                            message: `Não foi possivel deletar a configuração do ${rowToDelete.usuario}, tente novamente. Se o erro persistir, contate o suporte`,
                            closeable: true
                        });
                        canDeleteRef.current = true;
                    })
                    .finally(() => {
                        idToDeleteRef.current = null;
                        setStateLocal(prevState => ({
                            ...prevState,
                            showConfirmaDelete: false,
                            replicaOutrosEstabelecimentos: false
                        }));
                    });
            }
        }
        //eslint-disable-next-line
    }, [stateLocal.rows, stateLocal.replicaOutrosEstabelecimentos]);

    return (
        <Box
            sx={{
                height: 520,
                width: '100%',
                '& .actions': {
                    color: 'text.secondary',
                },
                '& .textPrimary': {
                    color: 'text.primary',
                },
            }}
        >

            <HeaderOuBannerDependendoDaInterpretacaoH1
                id='configuracoes-desconto'
                customIcon={
                    <CustomPercent id='vendaShoppingCarIcon' color={theme.palette.text.primary} fontSize={headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.normal} />
                }
                label="Configurar desconto e acréscimo"
            />

            <DataGrid
                rows={stateLocal.rows}
                columns={columns}
                editMode="row"
                rowModesModel={rowModesModel}
                onRowModesModelChange={handleRowModesModelChange}
                onRowEditStop={handleRowEditStop}
                processRowUpdate={processRowUpdate}
                slots={{
                    toolbar: EditToolbar,
                }}
                slotProps={{
                    toolbar: { setStateLocal, setRowModesModel },
                }}
                localeText={{
                    ...ptBR.components.MuiDataGrid.defaultProps.localeText,
                    noRowsLabel: "Nenhuma configuração encontrada"
                }}

            />
            {stateLocal.showAddConfiguracao &&
                <ConfiguracaoDescontoAcrescimoModal
                    onConfirm={onConfirmModal}
                    closeAddConfiguracao={closeAddConfiguracao}
                    usuarios={stateLocal.usuarios}
                    usuariosSelecionados={stateLocal.usuariosSelecionados}
                    onAddUsuario={addUsuario}
                    onAddAll={addAll}
                    onRemoveAll={removeAll}
                    descontoMaximoNoItem={stateLocal.descontoMaximoNoItem}
                    onSetMaxDescItem={setDescontoItem}
                    descontoMaximoPedido={stateLocal.descontoMaximoPedido}
                    onSetDescontoMaximoPedido={setDescontoMaxPedido}
                    acrescimoMaximoPedido={stateLocal.acrescimoMaximoPedido}
                    onSetAcrescimoMaximoPedido={setAcrescimoMaxPedido}
                    autorizaDesconto={stateLocal.autorizaDesconto}
                    autorizaDescontoOptions={[false, true]}
                    onChangeAutorizaDesconto={setAutorizaDesconto}
                    rows={stateLocal.rows}
                    usuarioEdit={stateLocal.usuarioEdit}
                    replicaOutrosEstabelecimentos={stateLocal.replicaOutrosEstabelecimentos}
                    onToggleReplicarConfiguracaoDesconto={onToggleReplicarConfiguracaoDesconto}
                />
            }
            {stateLocal.showConfirmaDelete &&
                <CustomDialog open onClose={onCloseDeleteModal}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        marginBottom: "10px",
                    }}>
                        <Icon className='fa-solid fa-triangle-exclamation' fontSize="large" />
                        <Typography sx={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            marginLeft: "10px"
                        }}>
                            Atenção
                        </Typography>
                    </Box>

                    <Typography sx={{
                        textAlign: "center"
                    }}>
                        Deseja realmente excluir a configuração de desconto desse usuário?
                    </Typography>

                    <Box sx={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "10px",
                        gap: "10px",
                        alignItems: "center"
                    }}>
                        <CustomSwitch
                            id='replicar-outros-estabelecimentos-delete'
                            checked={stateLocal.replicaOutrosEstabelecimentos}
                            name="replicar-outros-estabelecimentos-delete"
                            onChange={onToggleReplicarConfiguracaoDesconto}
                        />
                        <Typography>
                            Replicar a exclusão da configuração de desconto para todos os estabelecimentos vinculados a esse usuário?
                        </Typography>
                    </Box>

                    <Box display={'flex'} justifyContent={'space-between'} marginTop={'15px'}>
                        <CustomButton
                            disabled={false}
                            onClick={onCloseDeleteModal}
                            variant="contained"
                            color="error"
                        >
                            Cancelar
                        </CustomButton>

                        <CustomButton
                            disabled={false}
                            onClick={onConfirmDelete}
                            variant="contained"
                            color="success"
                        >
                            Excluir
                        </CustomButton>
                    </Box>

                </CustomDialog>
            }
            <Grid item
                sx={{
                    position: 'absolute',
                    bottom: '25px',
                    width: '80%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                }}
            >
                <CustomButton
                    sx={{ minWidth: '80px' }}
                    id="voltar-configuracao-vale-presente-btn"
                    onClick={props.onGoBack}
                    variant="contained"
                    color="error"
                    startIcon={<Icon className='fa-solid fa-arrow-left' />}>
                    Voltar
                </CustomButton>

                <CustomButton
                    sx={{ minWidth: '80px' }}
                    id="voltar-configuracao-vale-presente-btn"
                    onClick={() => navigate("/registra-venda")}
                    disabled={!caixaAberto ? true : false}
                    variant="contained"
                    color="success"
                    startIcon={<Icon className='fa-solid fa-check' />}>
                    Ir para o pdv
                </CustomButton>
            </Grid>
        </Box >

    );
};

export default ConfigurarDescontosAcrescimos;
